var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

export var NavBarBrand = function (_Component) {
  _inherits(NavBarBrand, _Component);

  function NavBarBrand() {
    _classCallCheck(this, NavBarBrand);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  NavBarBrand.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        brandUrl = _props.brandUrl,
        props = _objectWithoutProperties(_props, ["children", "brandUrl"]);

    return React.createElement(
      Link,
      _extends({ to: brandUrl, className: "sps-navbar__brand" }, props),
      children
    );
  };

  return NavBarBrand;
}(Component);

export var NavBarBrandLogo = function (_Component2) {
  _inherits(NavBarBrandLogo, _Component2);

  function NavBarBrandLogo() {
    _classCallCheck(this, NavBarBrandLogo);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  NavBarBrandLogo.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        brandLogo = _props2.brandLogo,
        brandName = _props2.brandName,
        props = _objectWithoutProperties(_props2, ["children", "brandLogo", "brandName"]);

    return React.createElement(
      Fragment,
      null,
      React.createElement("img", _extends({
        className: "sps-navbar__brand-logo",
        src: brandLogo,
        "aria-hidden": "true",
        alt: brandName
      }, props))
    );
  };

  return NavBarBrandLogo;
}(Component);

export var NavBarBrandName = function (_Component3) {
  _inherits(NavBarBrandName, _Component3);

  function NavBarBrandName() {
    _classCallCheck(this, NavBarBrandName);

    return _possibleConstructorReturn(this, _Component3.apply(this, arguments));
  }

  NavBarBrandName.prototype.render = function render() {
    var _props3 = this.props,
        children = _props3.children,
        brandName = _props3.brandName,
        props = _objectWithoutProperties(_props3, ["children", "brandName"]);

    return React.createElement(
      "span",
      _extends({ className: "sps-navbar__brand-name" }, props),
      brandName
    );
  };

  return NavBarBrandName;
}(Component);

export var NavBarVerticalRule = function (_Component4) {
  _inherits(NavBarVerticalRule, _Component4);

  function NavBarVerticalRule() {
    _classCallCheck(this, NavBarVerticalRule);

    return _possibleConstructorReturn(this, _Component4.apply(this, arguments));
  }

  NavBarVerticalRule.prototype.render = function render() {
    var _props4 = this.props,
        children = _props4.children,
        props = _objectWithoutProperties(_props4, ["children"]);

    return React.createElement("span", _extends({ className: "sps-vertical-rule" }, props));
  };

  return NavBarVerticalRule;
}(Component);

export var SpsNavBarItems = function (_Component5) {
  _inherits(SpsNavBarItems, _Component5);

  function SpsNavBarItems() {
    _classCallCheck(this, SpsNavBarItems);

    return _possibleConstructorReturn(this, _Component5.apply(this, arguments));
  }

  SpsNavBarItems.prototype.render = function render() {
    var _props5 = this.props,
        children = _props5.children,
        props = _objectWithoutProperties(_props5, ["children"]);

    return React.createElement(
      "div",
      _extends({ className: "sps-navbar__nav" }, props),
      children
    );
  };

  return SpsNavBarItems;
}(Component);

export var SpsNavBarItem = function (_Component6) {
  _inherits(SpsNavBarItem, _Component6);

  function SpsNavBarItem() {
    _classCallCheck(this, SpsNavBarItem);

    return _possibleConstructorReturn(this, _Component6.apply(this, arguments));
  }

  SpsNavBarItem.prototype.render = function render() {
    var _props6 = this.props,
        children = _props6.children,
        _props6$active = _props6.active,
        active = _props6$active === undefined ? false : _props6$active,
        props = _objectWithoutProperties(_props6, ["children", "active"]);

    var activeClassModifier = active ? "active" : "inactive";
    return React.createElement(
      "div",
      _extends({
        className: "sps-nav__item sps-nav__link " + activeClassModifier
      }, props),
      children
    );
  };

  return SpsNavBarItem;
}(Component);
export var NavBarContainer = function (_Component7) {
  _inherits(NavBarContainer, _Component7);

  function NavBarContainer() {
    _classCallCheck(this, NavBarContainer);

    return _possibleConstructorReturn(this, _Component7.apply(this, arguments));
  }

  NavBarContainer.prototype.render = function render() {
    var _props7 = this.props,
        children = _props7.children,
        fixed = _props7.fixed,
        props = _objectWithoutProperties(_props7, ["children", "fixed"]);

    return React.createElement(
      "div",
      _extends({
        className: classNames("sps-navbar-container", {
          "sps-navbar-container--fixed": fixed
        })
      }, props),
      React.createElement(
        "nav",
        { className: "navbar sps-navbar sps-navbar__nav--full-width" },
        children
      )
    );
  };

  return NavBarContainer;
}(Component);

var navLinkStyle = {
  textDecoration: "none"
};
var navLinkActiveStyle = {};
export var SpsNavBar = function (_Component8) {
  _inherits(SpsNavBar, _Component8);

  function SpsNavBar() {
    _classCallCheck(this, SpsNavBar);

    return _possibleConstructorReturn(this, _Component8.apply(this, arguments));
  }

  SpsNavBar.prototype.render = function render() {
    var _props8 = this.props,
        appUrl = _props8.appUrl,
        appLogo = _props8.appLogo,
        appName = _props8.appName,
        items = _props8.items,
        props = _objectWithoutProperties(_props8, ["appUrl", "appLogo", "appName", "items"]);

    if (typeof items !== "function") {
      throw Error("NavBar's items prop must be a function.");
    }
    return React.createElement(
      NavBarContainer,
      props,
      React.createElement(
        NavBarBrand,
        { brandUrl: appUrl },
        React.createElement(NavBarBrandLogo, { brandName: appName, brandLogo: appLogo }),
        React.createElement(NavBarBrandName, { brandName: appName })
      ),
      React.createElement(NavBarVerticalRule, null),
      items({
        SpsNavBarItems: SpsNavBarItems,
        SpsNavBarItem: SpsNavBarItem,
        navLinkStyle: navLinkStyle,
        navLinkActiveStyle: navLinkActiveStyle
      })
    );
  };

  return SpsNavBar;
}(Component);